import React from "react";

export default () => (
  <svg
    width="29"
    height="26"
    viewBox="0 0 29 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-[20.5px] h-[20.75px]"
  >
    <path
      d="M3.51375 5.5127H25.5138V8.0127H3.51375V5.5127ZM6.26375 0.512695H22.7638V3.0127H6.26375V0.512695ZM25.5 10.5002H3.5C2.77065 10.5002 2.07118 10.7636 1.55546 11.2324C1.03973 11.7013 0.75 12.3372 0.75 13.0002V23.0002C0.75 23.6632 1.03973 24.2991 1.55546 24.768C2.07118 25.2368 2.77065 25.5002 3.5 25.5002H25.5C26.2293 25.5002 26.9288 25.2368 27.4445 24.768C27.9603 24.2991 28.25 23.6632 28.25 23.0002V13.0002C28.25 12.3372 27.9603 11.7013 27.4445 11.2324C26.9288 10.7636 26.2293 10.5002 25.5 10.5002ZM12.1625 23.0002L7.625 18.9502L9.55 17.2002L12.1625 19.5752L19.45 12.9502L21.375 14.7002L12.1625 23.0002Z"
      fill="#545454"
    />
  </svg>
);
